import { QuotationMark } from '@dreamstack/icons/src/icon-components/QuotationMark'
import type { BlockSpeechBubble } from '@dreamstack/payload/src/payload-types'
import type { FunctionComponent } from 'react'

export const BigQuotationMarks: FunctionComponent<
  React.PropsWithChildren<{
    block: BlockSpeechBubble
  }>
> = ({ block }) => {
  const textField = block.text

  return (
    <div className="flex justify-start">
      <div className="relative flex">
        <QuotationMark className="flex-shrink-0 absolute top-px-12 -translate-x-1/2 left-0 h-px-24 w-[28px] text-accentroAqua-100 md:static md:translate-x-0 md:h-px-32 md:w-px-40 md:mt-px-16 md:mr-px-8" />
        <span className="text-px-20 leading-px-30 font-semibold text-accentroAqua-full md:text-px-28 md:leading-px-42 ml:text-px-40 ml:leading-px-50 relative">
          {textField}&nbsp;
          <QuotationMark className="absolute -translate-x-1/2 inline flex-shrink-0 h-px-24 w-[28px] text-accentroAqua-100 rotate-180 md:static md:translate-x-0 md:h-px-32 md:w-px-40 md:mb-px-8" />
        </span>
      </div>
    </div>
  )
}
